export const LIST_USERS = "LIST_USERS";
export const CREATE_USER = "CREATE_USER";
export const LIST_CLIENTS = "LIST_CLIENTS"
export const LIST_APPS = "LIST_APPS"
export const USER_CLIENTS = "USER_CLIENTS"

export const END_URL = {
    USERS: '/user/all',
    USER: '/user/get',
    CREATE: '/user/create',
    UPDATE: '/user/update',
    CLIENT: '/permission/client',
    APPLICATION: '/application/all',
    PERMISSION_UPDATE: '/permission/assign',
    USER_CLIENTS: "/permission/clients"
}

export const VALIDATION = {
    REQUIRED: "Required!",
    INVAL_EMAIL: "Invalid Email",
    SYSTEM_ERROR: "System Error",
    EMPTY_CLIENT: "Please select at least one advertiser",
    LENGTH: "Min Character Lenth is 6 "
}
export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    DEACTIVE: 'Deactive',
    ACTIVE: 'Active',
    ACTIVATE: 'Activate',
    DEACTIVATE: 'Deactivate'
}

export const STRING = {
    CHARACTER_LENGTH: 6,
    USER: 'User',
    MODAL_TITLE: 'Are you sure?',
    YES: 'Yes',
    NO: 'No',
    ADD_NEW: 'Add New User',
    NO_DATA: 'No data',
    COL: [
        { name: 'id', title: 'ID' },
        { name: 'name', title: 'Name' },
        { name: 'email', title: 'Email' },
        { name: 'role', title: 'Role' },
        { name: 'status', title: 'Status' },
        { name: 'actions', title: 'Actions' }
    ],
    COL_STYLES: [
        { columnName: 'id', align: 'right', width: 70 },
        { columnName: 'actions', align: 'center', width: 150 },
        { columnName: 'role', width: 100 },
        { columnName: 'status', width: 100 }
    ],
    USER_TYPE: [
        { value: 'USER', label: 'USER' },
        { value: 'ADMIN', label: 'ADMIN' }
    ]
}
export function validateEmail(email) {
    return (!/\S+@\S+\.\S+/.test(email))
}